
import MetricCard from "@/components/stats/cards/MetricCard";
import { LucideIcon } from "lucide-react";

interface StatsCardProps {
  title: string;
  value: string;
  description: string;
  icon: LucideIcon;
  trend?: {
    value: number;
    isPositive: boolean;
  };
}

// This component is kept for backward compatibility
const StatsCard = (props: StatsCardProps) => {
  return <MetricCard {...props} />;
};

export default StatsCard;
